<template>
  <div class="black-list-container">
    <!-- <div class="header-content">
      <div class="btn-content" @click="addList" v-auth="'/personMg:add'"><i class="iconfont icon-xinzeng"></i>{{$t('personMg.button.add')}}</div>
      <div class="btn-content" @click="listUpdate" v-auth="'/personMg:update'"><i class="iconfont icon-xiugai"></i>{{$t('personMg.button.edit')}}</div>
      <div class="btn-content" @click="deleteclick" v-auth="'/personMg:delete'"><i class="iconfont icon-shanchu"></i>{{$t('personMg.button.delete')}}</div>
      <div class="btn-content" @click="detailClick"><i class="icon el-icon-document"></i>{{$t('personMg.button.view')}}</div>
    </div> -->
    <div class="search-content">
      <el-input v-model="name" clearable @keyup.enter.native="getBlackList">
        <i slot="prefix" class="el-input__icon el-icon-search" @click="getBlackList"></i>
      </el-input>
    </div>
    <!-- 自定义名单树 -->
    <div class="list-content sbar">
      <el-scrollbar style="height:100%;">
      <div class="list-item" v-for="(items, indexs) in blackListData" :key="indexs">
        <div class="title" style="position:relative;">
          <i class="el-icon-caret-bottom" @click="listTitleClick(indexs)">&nbsp;&nbsp;{{items.name}}</i>
          <!-- <div style="changeStyle">
            <div @click="addList(items)" v-auth="'/personMg:add'" class="iconStyle el-icon-plus">
            </div>
          </div> -->
        </div>
        <ul class="show">
          <li style="position:relative;" :title="item.name" v-for="(item, index) in items.children" :key="index" :class="(indexs === nowIndex.parentIndex && index === nowIndex.childrenIndex) ? 'active list-text' : 'list-text'" @click="listItemClick(item, indexs, index)">
            <span>{{item.name|ellipsis}}</span>
            <!-- <span style="position:absolute;right:10px;" class="iconStyle el-icon-delete" @click="deleteDate(item)"></span> -->
          </li>
        </ul>
      </div>
      </el-scrollbar>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog
      :title="state === 1 ? this.$t('personMg.title.addGroup') : this.$t('personMg.title.editGroup')"
      v-ops:width="680"
      v-dialogDrag
      :visible.sync="formShow"
      @close="formClose"
      :close-on-click-modal="false">
      <ioc-form :option="formOption" v-model="formData" ref="form"></ioc-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addBackList" v-status>
          {{$t('personMg.button.save')}}
        </el-button>
        <el-button @click="formClose">
          {{$t('personMg.button.cancel')}}
        </el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      :title="$t('personMg.title.detailGroup')"
      :visible.sync="detailShow"
      v-dialogDrag
      :close-on-click-modal="false"
      width="680px">
      <ioc-form :option="detailOption" v-model="detailData"></ioc-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Close">
          {{$t('personMg.button.close')}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {api} from '../api'
import i18n from '@src/common/lib/i18n'

// const textCheck = (rule, value, callback) => {
//   const reg = /^[\u4E00-\u9FA5\w\d]+$/u
//   if (!reg.test(value)) {
//     callback(new Error("允许中文、字母、数字、空格、'·'、'.'、'-'，且首不能为'·'、'.'、'-'"))
//   } else {
//     callback()
//   }
// }

const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, '');
}
const textCheck = (rule, value, callback) => {
  const str = trim(value)
  if (str.length === 0) {
    callback(new Error(i18n.t('personMg.message.blackName')))
  } else if (str[0] === '.' || str[0] === '·' || str[0] === '-') {
    callback(new Error(i18n.t('personMg.message.value')))
  } else {
    const reg = /^[\u4e00-\u9fa5a-zA-Z0-9. ·-]*[\u4e00-\u9fa5a-zA-Z0-9. ·-]$/
    if (!reg.test(str)) {
      callback(new Error(i18n.t('personMg.message.value')))
    } else {
      callback()
    }
  }
}


export default {
  props:{
    objectList:{
      type:Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      nowIndex: {
        parentIndex: 1,
        childrenIndex: 1
      },
      detailShow: false,
      nowCode: {}, // 当前名单组数据
      formShow: false,
      repositorCode: '', // 库ID
      state: 1, // 1: 新增 2：修改
      // 表单配置项
      formOption: {
        labelWidth: 120,
        emptyBtn: false,
        submitBtn: false,
        column: [{
          label: this.$t('personMg.label.groupName'),
          span: 18,
          prop: 'name',
          rules: [
            {
              required: true,
              message: this.$t('personMg.message.groupName'),
              trigger: 'change'
            }
          ]
        }, {
          label: this.$t('personMg.label.remark'),
          span: 18,
          prop: 'desc',
          type:'textarea',
          rules: [
            {
              required: true,
              message: this.$t('personMg.message.remark'),
              trigger: 'blur'
            },
            {validator: textCheck, trigger: 'blur'}
          ],
          minlength: 1,
          maxlength: 50,
        }]
      },
      // 详情配置项
      detailOption: {
        labelWidth: 120,
        emptyBtn: false,
        submitBtn: false,
        column: [{
          label: this.$t('personMg.label.groupType'),
          span: 24,
          prop: 'type',
          type: 'select',
          dicData: [{
            label: this.$t('personMg.label.groupBlack'),
            value: 2
          }, {
            label: this.$t('personMg.label.whiteBlack'),
            value: 3
          }, {
            label: this.$t('personMg.label.redBlack'),
            value: 4
          }],
          disabled: true,
        }, {
          label: this.$t('personMg.label.groupName'),
          span: 24,
          prop: 'name',
          disabled: true,
        }]
      },
      // 表单数据
      formData: {
        name: '',
        type: '',
        desc: ''
      },
      // 详情数据
      detailData: {
        name: '',
        desc: ''
      },
      name: '',
      blackListData: [
        {
          name: this.$t('personMg.label.groupBlack'),
          isParent: true,
          children: []
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  watch: {
    objectList :{
      handler(val, oldVal){
        console.log('objList_val',val)
        console.log('objList_oldVal',oldVal);
        this.getBlackList(val)
      },
      deep:true
    },
    name (val) {
        if (val.length) {
            return false
        }
        this.getBlackList()
    },
    nowCode: {
      handler(val, oldVal){
        this.blackListData.map((item, ind) => {
          if(val.type === item.type){
            this.$parent.formList = this.blackListData[ind].children
          }
        })
        this.$emit('queryBackList', val.code)
      },
      deep:true
    },
    blackListData: {
      handler(newValue, oldValue) {
        newValue.map((item, ind) => {
          if(this.nowCode.type === item.type){
            this.$parent.formList = this.blackListData[ind].children
          }
        })
      },
      deep: true
    },
    state (oldVal, newVal) {
      if (oldVal === 1) {
        this.formOption.column = [{
          label: this.$t('personMg.label.groupType'),
          span: 24,
          prop: 'type',
          type: 'select',
          dicData: [{
            label: this.$t('personMg.label.groupBlack'),
            value: 2
          }, {
            label: this.$t('personMg.label.whiteBlack'),
            value: 3
          }, {
            label: this.$t('personMg.label.redBlack'),
            value: 4
          }]
        }, {
          label: this.$t('personMg.label.groupName'),
          span: 24,
          prop: 'name'
        }]
      } else {
        this.formOption.column.splice(0, 1)
      }
    }
  },
  mounted () {
    // this.getBlackList();
    this.queryFaceType()
  },
  methods: {
    addList(type) {
      this.formData.type = type;
      this.state = 1; 
      this.formShow = true
      this.$refs['form'].clearValidate()
    },
    // 修改名单组弹窗显示
    listUpdate () {
      if (this.nowCode.type === -1) {
        this.$message.warning(this.$t('personMg.placeholder.choseGroup'))
        return false
      }
      this.formData = {
        name: this.nowCode.name,
        type: this.nowCode.type
      }
      this.state = 2
      this.formShow = true
    },
    // 新增修改弹窗 关闭清除数据
    formClose () {
      this.formShow = false
      this.formData = {
        name: '',
        type: ''
      }
      this.$refs['form'].clearValidate()
    },
    // 详情
    detailClick () {
      if (this.nowCode.type === -1) {
        this.$message.warning(this.$t('personMg.placeholder.choseGroup'))
        return false
      }
      this.detailData = {
        name: this.nowCode.name,
        type: this.nowCode.type
      }
      this.detailShow = true
    },
    // 删除
    deleteclick () {
      if (this.nowCode.type === -1) {
        this.$message.warning(this.$t('personMg.placeholder.choseGroup'))
        return false
      }
      this.$confirm(this.$t('personMg.message.groupDel'), this.$t('personMg.title.remind'), {
        confirmButtonText: this.$t('personMg.button.confirm'),
        cancelButtonText: this.$t('personMg.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.$fetch(api.deleteFaceGroup, {
          code: this.nowCode.code
        }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('personMg.message.successDel'))
            this.getBlackList()
          } else {
            this.$message.error(res.msgContent)
          }
        })
      })
    },
    // 新增/修改名单组
    addBackList () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let url = this.state === 1 ? api.addFaceGroup : api.updateFaceGroup
          let params = {}
          if (this.state === 1) {
            params = {
              name: trim(this.formData.name),
              desc: this.formData.desc,
              type: this.formData.type
            }
          } else {
            params = {
              name: trim(this.formData.name),
              code: this.nowCode.code
            }
          }
          this.$fetch(url, params).then(res => {
            if (res.success) {
              this.$message.success(this.state === 1 ? this.$t('personMg.title.addOk') : this.$t('personMg.title.editOk'))
              this.formShow = false
              this.getBlackList()
            } else {
              this.$message.error(this.state === 1 ? res.msgContent : res.msgContent)
            }
          })
        } else {
          return false
        }
      })
    },
    // 请求名单组
    getBlackList (objectList) {
        // if (!res.success) {
        //   this.$message.error(res.msgContent)
        //   return false
        // }
        this.blackListData.forEach(item => {
          item.children.length = 0
        })
        if (objectList.length === 0) {
          $('.show .list-text').remove()
        }
        objectList.map(item1 => {
          // if (item.type === 2) {
          //   this.blackListData[0].children.push(item)
          // } else if (item.type === 3) {
          //   this.blackListData[1].children.push(item)
          // } else {
          //   this.blackListData[2].children.push(item)
          // }
          this.blackListData.map((item2) => {
            if(item1.type === item2.type) {
              item2.children.push(item1)
            }
          })
        })

         this.blackListData.some((item, ind) => {
          if(item.children && item.children[0]){
            this.nowCode = item.children[0]
            this.nowIndex = {
              parentIndex: ind,
              childrenIndex: 0
            }
            return true
          }else{
            this.nowCode = {
              type: -1
            }
          }
        })
    },
    // 名单组点击回调
    listItemClick (data, indexs, index) {
      this.nowIndex = {
        parentIndex: indexs,
        childrenIndex: index
      }
      this.nowCode = data
      this.$emit('changeObject',data)
    },
    // 名单组标题点击事件
    listTitleClick (indexs) {
      console.log(indexs, '名单组标题点击事件')
      let dom = $('.black-list-container .list-content .list-item .title')[indexs]
      $(dom).children('i')[0].className === 'el-icon-caret-bottom' ? $(dom).children('i')[0].className = 'el-icon-caret-right' :  $(dom).children('i')[0].className = 'el-icon-caret-bottom'
      $(dom).next()[0].className === 'show' ? $(dom).next()[0].className = 'hide' :  $(dom).next()[0].className = 'show'
      // console.log('dom', dom);
      // console.log('domName', $(dom).children('i')[0].className);
      console.log('domNext', $(dom).next()[0].className);
    },
    Close(){
      this.detailShow = false
    },
    // 删除黑白名单组
    deleteDate(data){
      console.log('data',data)
    },
    queryFaceType(){
      Dic.find('SENU027').map((item, ind) => {
        this.blackListData.push({
          name: item.label,
          type: item.value,
          isParent: true,
          children: []
        })  
      })
      console.log( this.blackListData , 'blackListData')
    }
  }
}
</script>
<style scoped>
.person-mg .left-content .black-list-container {
  padding: 0 10px;
}
.iconStyle{
  position:absolute;
  right:10px;top:25%;
  padding:1px 2px 1px 2px;
  background:#383f6e;
}

</style>>